import Address from "@mapmycustomers/shared/types/Address";
import Located from "@mapmycustomers/shared/types/base/Located";

const locatedToAddress = ({
  address,
  city,
  country,
  countryCode,
  postalCode,
  region,
  regionCode,
}: Pick<
  Located,
  "address" | "city" | "country" | "countryCode" | "postalCode" | "region" | "regionCode"
>): Address => ({
  address: address ?? undefined,
  city: city ?? undefined,
  country: country ?? undefined,
  countryCode: countryCode ?? undefined,
  postalCode: postalCode ?? undefined,
  region: region ?? undefined,
  regionCode: regionCode ?? undefined,
});

export default locatedToAddress;
